import React from 'react';
import AddDroit from './AddDroit';
import ListeDroit from './ListeDroit';
import MyCard from '../../../../components/Common/MyCard';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../../util/apiClient';
import { IDroit, setDroits } from './droitSlice';
import { useDispatch } from 'react-redux';

const Droit = () => {


    return (
        <div>
            <MyCard
                titleCard="Droit"
                addComponent={<AddDroit />}
                content={<ListeDroit /> }
            />
        </div>
    );
}

export default Droit;
